import { useCallback, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleQuestion } from '@fortawesome/pro-regular-svg-icons';
import { trackEvent } from '@services/tracking';
import { MissingOnboardingStep } from '../home.viewModel';
import { GoLiveRequirementsModal } from './GoLiveRequirementsModal';

type GoLiveHelpButtonProps = {
  missingSteps: MissingOnboardingStep[];
};

export const GoLiveHelpButton = ({ missingSteps }: GoLiveHelpButtonProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const closeGoLiveRequirements = useCallback(() => {
    setIsOpen(false);
  }, []);

  const openGoLiveRequirements = useCallback(() => {
    trackEvent({
      type: 'Go Live hint opened',
      payload: { 'Missing steps': JSON.stringify(missingSteps) },
    });
    setIsOpen(true);
  }, [missingSteps]);

  return (
    <>
      <button
        type="button"
        aria-label="Why is Go live disabled?"
        onClick={openGoLiveRequirements}
        className="inline-flex items-center justify-center w-8 h-8 rounded-full border-0 bg-transparent cursor-pointer text-lg text-[#737373] hover:text-[#6E45B7] p-0"
      >
        <FontAwesomeIcon icon={faCircleQuestion} />
      </button>
      <GoLiveRequirementsModal
        isOpen={isOpen}
        onClose={closeGoLiveRequirements}
        missingSteps={missingSteps}
      />
    </>
  );
};
